/**
 * La cara de un colaborador.
 *
 * Los retratos existían desde julio y solo los enseñaba el panel de Word. Ponerlos aquí no es
 * decoración: una lista de dieciocho pares de iniciales sobre círculos de dos colores obliga a
 * leer cada nombre para saber a quién estás mirando; dieciocho caras se distinguen de un vistazo,
 * que es lo que hace que una barra de conversaciones se recorra en vez de leerse.
 *
 * Si falta el retrato caen las iniciales, con el oro o el cian de la marca repartidos de forma
 * estable por identificador: la cara de alguien no puede cambiar de color entre dos sesiones.
 */
import { caraDe } from "../caras";

const INICIALES = (n: string) =>
  n.split(" ").filter((p) => p.length > 2).map((p) => p[0]).join("").slice(0, 2).toUpperCase();

function tono(id: string) {
  let n = 0;
  for (const ch of id) n = (n * 31 + ch.charCodeAt(0)) >>> 0;
  return n % 2
    ? { background: "var(--acc-suave)", color: "var(--acc)" }
    : { background: "var(--azul-suave)", color: "var(--azul)" };
}

export default function Cara({ id, nombre, clase = "" }: { id: string; nombre: string; clase?: string }) {
  const retrato = caraDe(id);
  return (
    <span className={"cara" + (clase ? " " + clase : "")} style={retrato ? undefined : tono(id)}>
      {retrato ? <img src={retrato} alt="" /> : INICIALES(nombre)}
    </span>
  );
}
